/* eslint-disable no-self-compare */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-named-as-default-member */
/**
 * #######################################################@
 *
 * Pages settings
 *
 * #######################################################@
 */
import "./style.css";

import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";

import { Backdrop, CircularProgress, Divider, Icon } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import ChartsActions from "redux-react/actions/chartsActions";
import ProfileActions from "redux-react/actions/profileActions";
import SettingsActions from "redux-react/actions/settingsActions";
import { display } from "redux-react/reducers/snackBarReducer";

import ConfirmDialog from "components/Custom/Dialogs/ConformDialog";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import PagesDataTable from "components/Custom/Tables/PagesDataTable";
import MDButton from "components/Basics/MDButton";
import MDBox from "components/Basics/MDBox";
import i18n from "i18n";
import AddPageDialog from "./AddPageDialog";
import EditPageDialog from "./EditPageDialog";

export default function SettingsPages({ route }) {
	const { user } = useSelector(state => state);
	const dispatch = useDispatch();

	const [paginedList, setPaginedList] = useState(null);
	const [filtersList, setFiltersList] = useState(null);

	const [addNewPage, setAddNewPage] = useState(false);
	const [tableLoading, setTableLoading] = useState(false);
	const [editPage, setEditPage] = useState({ open: false });
	// Confirm dialog
	const [confirmDialog, setConformDialog] = useState({
		open: false,
		title: "",
		content: "",
		handleConfirm: () => {}
	});
	/**
	 * Load pagined list
	 */
	function loadPaginedList() {
		const onSuccess = res => {
			setPaginedList(res.paginedList[0]);
			setTableLoading(false);
		};

		dispatch(ChartsActions.getPaginedList(route, onSuccess));
		// get filters
		dispatch(
			SettingsActions.getSettings("filters", res => {
				setFiltersList(res.documents);
			})
		);
	}
	/**
	 * Save new page
	 */
	function handleSaveNewPage(page) {
		const onSuccess = res => {
			dispatch(
				display({
					message: i18n.t("SETTINGS.PAGES.SUCCESS.add"),
					type: "success"
				})
			);
			loadPaginedList();
			dispatch(ProfileActions.updateMenu(user.accountID));
		};
		dispatch(SettingsActions.newSetting("page", page, onSuccess));
	}
	/**
	 * Handle page reorder
	 * @param {Number} from
	 * @param {Number} to
	 */
	function handleReorderPage(from, to) {
		const onSuccess = res => {
			dispatch(
				display({
					message: i18n.t("SETTINGS.PAGES.SUCCESS.edit"),
					type: "success"
				})
			);

			loadPaginedList();
			dispatch(ProfileActions.updateMenu(user.accountID));
		};
		let data = { from, to };
		dispatch(SettingsActions.reorderPage(data, onSuccess));
	}
	/**
	 * Handle edit page
	 */
	function actionEditHandle(page) {
		const onSuccess = res => {
			dispatch(
				display({
					message: i18n.t("SETTINGS.PAGES.SUCCESS.edit"),
					type: "success"
				})
			);
			loadPaginedList();
			dispatch(ProfileActions.updateMenu(user.accountID));
		};
		dispatch(SettingsActions.editSetting("page", page, onSuccess));
	}
	/**
	 * Handle delete page
	 */
	function actionDeleteHandle(page) {
		const handleConfirmDialog = () => {
			setConformDialog({
				open: false
			});
			const onSuccess = res => {
				dispatch(
					display({
						message: i18n.t("SETTINGS.PAGES.SUCCESS.delete"),
						type: "success"
					})
				);
				loadPaginedList();
				dispatch(ProfileActions.updateMenu(user.accountID));
			};
			dispatch(SettingsActions.deleteSetting("page", { rank: page.rank }, onSuccess));
		};

		setConformDialog({
			open: true,
			title: `${i18n.t("SETTINGS.delete")} : ${i18n.t(`SETTINGS.PAGES.${page.type}`)} ${
				page.name ? `"${page.name}"` : ""
			}`,
			content: `${i18n.t("SETTINGS.deleteConfirmation")} : ${i18n.t(
				`SETTINGS.PAGES.${page.type}`
			)} ${page.name ? `"${page.name}"` : ""} ?`,
			handleConfirm: handleConfirmDialog
		});
	}
	/**
	 * Load pages list on mount
	 */
	useEffect(() => {
		loadPaginedList();
	}, []);

	/**
	 * When user create a page, set page's rank to the next rank
	 */
	function getNextRank(rows) {
		const maxRank = rows.reduce((acc, row) => {
			if (row.rank > acc) {
				return row.rank;
			}
			return acc;
		}, 0);
		return maxRank + 1;
	}

	return (
		<DashboardLayout>
			<DashboardNavbar
				filters={[
					<MDBox display="flex">
						<MDButton
							style={{ height: "100%", marginRight: "0.75rem" }}
							variant="contained"
							color="info"
							onClick={() => setAddNewPage(true)}
						>
							<Icon>add</Icon>&nbsp;{i18n.t("SETTINGS.PAGES.addPage")}
						</MDButton>
					</MDBox>
				]}
			/>
			<Divider />
			{paginedList && (
				<div
					style={{
						position: "relative",
						width: "100%",
						height: "100%"
					}}
				>
					{tableLoading && (
						<div
							style={{
								width: "100%",
								height: "100%",
								backgroundColor: "rgba(0,0,0,0.2)",
								position: "absolute",
								top: 0,
								left: 0,
								zIndex: 100,
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								borderRadius: 10
							}}
						>
							<CircularProgress color="info" />
						</div>
					)}
					<PagesDataTable
						draggable
						table={paginedList.data}
						display={paginedList.request.attributesDisplay}
						actionEditHandle={page => setEditPage({ ...page, open: true })}
						actionDeleteHandle={actionDeleteHandle}
						dragHandler={({ from, to }) => {
							if (from === to) return;
							setTableLoading(true);
							handleReorderPage(from, to);
						}}
					/>
				</div>
			)}
			{paginedList && (
				<AddPageDialog
					dictionary={paginedList.dictionary}
					permissionsList={paginedList.permissionsList}
					open={addNewPage}
					handleCloseDialog={() => setAddNewPage(false)}
					handleSave={handleSaveNewPage}
					rank={getNextRank(paginedList.data.rows)}
					filtersList={filtersList}
				/>
			)}
			{paginedList && (
				<EditPageDialog
					open={editPage.open}
					dictionary={paginedList.dictionary}
					handleCloseDialog={() => setEditPage({ open: false })}
					handleSave={actionEditHandle}
					page={editPage}
					filtersList={filtersList}
				/>
			)}
			<ConfirmDialog
				open={confirmDialog.open}
				title={confirmDialog.title}
				content={confirmDialog.content}
				handleClose={() => {
					setConformDialog({
						open: false
					});
				}}
				handleConfirm={confirmDialog.handleConfirm}
			/>
		</DashboardLayout>
	);
}
